<template lang="html">
    <div class="formGroup">
        <textarea-autosize
            @input="debounceInput"
            :disabled="!editMode"
            v-model="record.content"
            :min-height="30"
        />
        <button
            v-if="editMode && deleteOpen"
            class="button red"
            @click.prevent="deleteSection"
            type="button"
        >
            <img src="@/assets/minus.svg" class="icon" />
        </button>
    </div>
</template>

<script>
var debounce = require("debounce");
export default {
    name: "content-text",
    props: ["record", "value", "index", "editMode"],
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    data() {
        return {
            deleteOpen: true,
        };
    },
    methods: {
        deleteSection() {
            this.$emit("sectionDeleted", this.index, this.record);
        },
        debounceInput: debounce(function () {
            this.$emit("saveData");
        }, 800),
    },
};
</script>

<style lang="scss" scoped>
.formGroup {
    position: relative;

    textarea:disabled {
        -webkit-text-fill-color: #267962 !important;
        opacity: 1;
        font-weight: 400 !important;
    }
}
.button {
    position: absolute;
    right: 10px;
    width: 40px !important;
    height: 40px !important;
    border-radius: 8px !important;
    top: -10px;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
    .icon {
        width: 9px;
    }
}
</style>
